import { Component } from '@angular/core';
import { StorageService } from '../../services/common/storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordMessageDialogueComponent } from '../password-message-dialogue/password-message-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent {
  changePasswordForm!: FormGroup;
  passwordinputType = 'password';
  confirmPasswordinputTypes = 'password';
  currentPasswordInputType = 'password'
  userTypeId: number;

  constructor(
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private translate:TranslateService,
    private languageService: LanguageService,
  ) {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    this.changePasswordForm = this.formBuilder.group({
      currentPassword: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.passwordRegex),
        ],
      ],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.passwordRegex),
        ],
      ],
      confirmPassword: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.passwordRegex),
        ],
      ],
    });
    let UserDetails = this.storageService?.getTokenData();
    this.userTypeId =  UserDetails?.UserTypeId ?? 0;
  }

  changeInputType(input_type: any, fieldName: any) {
    if (fieldName == 'password') {
      if (input_type == 'password') {
        this.passwordinputType = 'text';
      } else {
        this.passwordinputType = 'password';
      }
    } else if (fieldName == 'confirmPassword') {
      if (input_type == 'password') {
        this.confirmPasswordinputTypes = 'text';
      } else {
        this.confirmPasswordinputTypes = 'password';
      }
    }
    else if(fieldName == 'changepassword'){
      if (input_type == 'password') {
        this.currentPasswordInputType = 'text';
      } else {
        this.currentPasswordInputType = 'password';
      }
    }
  }
  onChangePasssword() {
    Object.keys(this.changePasswordForm.controls).forEach((key) => {
      const control = this.changePasswordForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });

    if (this.changePasswordForm.valid) {
      const FormData = {
        CurrentPassword:
          this.changePasswordForm.controls['currentPassword'].value,
        NewPassword: this.changePasswordForm.controls['newPassword'].value,
        ConfirmPassword:
          this.changePasswordForm.controls['confirmPassword'].value,
      };
      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.account.changePassword;
      this.apiService
        .doPost(apiUrl, FormData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              const dialogRef = this.dialog.open(
                PasswordMessageDialogueComponent,
                {
                  width: '600px',
                  data: {
                    // data will be based on API response
                    passwordError: false,
                    message:'CHANGE_PASSWORD_SUCCESS_MSG',
                    title: 'CHANGE_PASSWORD_SUCCESS_TITLE',
                  },
                }
              );

              dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                  this.router.navigate(['/login']);
                }
              });
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            console.error(er);
            this.toaster.error(er.Message);
          },
        });
    }
  }

  goBack() {
    window.history.back();
  }
}
